<template>
  <v-dialog class="upload-progress-overlay" v-model="showProgress" persistent max-width="400">
    <v-card>
      <v-card-title class="text-center">
        <v-icon left color="primary">mdi-video</v-icon>
        رفع الفيديو التعريفي
      </v-card-title>
      
      <v-card-text>
        <div v-if="!uploadComplete">
          <div class="text-center mb-4">
            <v-progress-circular
              :value="uploadProgress"
              :size="80"
              :width="8"
              color="primary"
            >
              {{ uploadProgress }}%
            </v-progress-circular>
          </div>
          
          <v-progress-linear
            :value="uploadProgress"
            height="20"
            color="primary"
            rounded
          >
            <template v-slot:default="{ value }">
              <strong>{{ Math.ceil(value) }}%</strong>
            </template>
          </v-progress-linear>
          
          <div class="text-center mt-3">
            <v-chip color="secondary" small>
              جاري رفع الفيديو...
            </v-chip>
          </div>
        </div>
        
        <div v-else class="text-center">
          <v-icon size="64" color="success" class="mb-3">
            mdi-check-circle
          </v-icon>
          <h3 class="success--text mb-2">تم رفع الفيديو بنجاح</h3>
          <p class="text-body-2 grey--text">
            تم رفع الفيديو التعريفي بنجاح
          </p>
        </div>
      </v-card-text>
      
      <v-card-actions v-if="uploadComplete" class="justify-center">
        <v-btn
          color="accent"
          rounded
          @click="closeDialog"
        >
          تم
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { EventBus } from "@/main";

export default {
  name: "VideoUploadProgress",
  data() {
    return {
      showProgress: false,
      uploadProgress: 0,
      uploadComplete: false,
    };
  },
  mounted() {
    // Listen for upload progress events
    EventBus.$on("videoUploadProgress", this.updateProgress);
    EventBus.$on("videoUploadComplete", this.completeUpload);
    EventBus.$on("videoUploadStart", this.startUpload);
  },
  beforeDestroy() {
    // Clean up event listeners
    EventBus.$off("videoUploadProgress", this.updateProgress);
    EventBus.$off("videoUploadComplete", this.completeUpload);
    EventBus.$off("videoUploadStart", this.startUpload);
  },
  methods: {
    startUpload() {
      this.showProgress = true;
      this.uploadProgress = 0;
      this.uploadComplete = false;
    },
    updateProgress(progress) {
      this.uploadProgress = progress;
    },
    completeUpload() {
      this.uploadProgress = 100;
      this.uploadComplete = true;
    },
    closeDialog() {
      this.showProgress = false;
      this.uploadProgress = 0;
      this.uploadComplete = false;
    },
  },
};
</script>

<style scoped>
.v-progress-circular {
  margin: 0 auto;
}

.upload-progress-overlay {
    z-index: 9999;
}
</style> 